import React, { useState } from "react";
import Modal from "./Modal";


export default function ModalComponent({ open, title, children, handleOpen }) {
  if (!open) return null;

  return (
    <Modal>
      <div className="max-w-full sm:max-w-full mx-auto bg-white p-4 sm:p-3 rounded-lg shadow-md">
        <h1 className="text-lg font-bold text-gray-700">{title}</h1>
        <hr className="my-2" />
        <div className="text-gray-600">{children}</div>
      </div>
    </Modal>
  );
}